import React from 'react';

import * as Styled from './StyledContainer';

export const ContainerBody = ({ children, ...props }) => (
    <Styled.ContainerBody {...props}>{children}</Styled.ContainerBody>
);
